enum GROUP_TYPE {
  ACCORDION = 'ACCORDION',
  ADVANTAGE_LIST = 'ADVANTAGE_LIST',
  ADVANTAGE_LIST_NO_BUTTON = 'ADVANTAGE_LIST_NO_BUTTON',
  CONTACT_US = 'CONTACT_US',
  CTA_BUTTON = 'CTA_BUTTON',
  HOW_TO_GO_NEXT = 'HOW_TO_GO_NEXT',
  LOGO_BOARD = 'LOGO_BOARD',
  LOGOS = 'LOGOS',
  ORDERED_LIST = 'ORDERED_LIST',
  PLAYER = 'PLAYER',
  REVIEW = 'REVIEW',
  QUESTION = 'QUESTION',
}

export default GROUP_TYPE;
